import { css } from "styled-components";
import token from "styled-token";
import { typographyMixin } from "../typographyMixin";
import { spaceMixin } from "../spaceMixin";
import { FONT_TYPES } from "../../constants/FONT_TYPES";
import { StyledButton } from "../../components/Button/Button";
import { StyledIcon } from "../../components/Icon/Icon";
/** @class DatePickerSelectMixin */

/** @method */

export var DatePickerSelectMixin = function DatePickerSelectMixin(props) {
  return token({
    size: "DatePicker.caretSize",
    iconSize: "DatePicker.caretIconSize",
    hoverColor: "colors.gray200",
    boxShadow: "shadows.focus"
  }, function (tokens) {
    return css(["position:relative;display:inline-block;padding-left:", ";select{appearance:none;border:none;background:none;box-shadow:none;cursor:pointer;padding:0;padding-right:", ";", " height:", "px;line-height:", "px;&:hover{& + button{background-color:", ";}}&:focus{outline:0;& + ", "{box-shadow:", ";}}&::-ms-expand{display:none;}}", "{position:absolute;top:0;right:0;pointer-events:none;width:", "px;height:", "px;", "{height:", "px;width:", "px;transform:rotate(90deg);}}"], spaceMixin(0.5)(props), spaceMixin("lg")(props), typographyMixin(Object.assign({
      fontType: FONT_TYPES.bodyHeading
    }, props)), tokens.size, tokens.size, tokens.hoverColor, StyledButton, tokens.boxShadow, StyledButton, tokens.size, tokens.size, StyledIcon, tokens.iconSize, tokens.iconSize);
  })(props);
};